/* Testimonial carousel — the arrows scroll the card track by exactly one card,
   including the gap. Native scrolling and scroll-snap do the rest, so the cards
   stay swipeable on touch even without this script. */

class ReviewCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-cards]');
    if (!this.track) return;

    this.prev = this.querySelector('[data-prev]');
    this.next = this.querySelector('[data-next]');

    if (this.prev) this.prev.addEventListener('click', () => this.move(-1));
    if (this.next) this.next.addEventListener('click', () => this.move(1));

    this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
    this.updateArrows();
  }

  step() {
    const card = this.track.querySelector('.tst-card');
    if (!card) return 0;
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  move(direction) {
    const distance = this.step();
    if (!distance) return;
    this.track.scrollBy({ left: direction * distance, behavior: 'smooth' });
  }

  updateArrows() {
    const max = this.track.scrollWidth - this.track.clientWidth;
    const atStart = this.track.scrollLeft <= 1;
    const atEnd = this.track.scrollLeft >= max - 1;

    if (this.prev) this.prev.disabled = atStart;
    if (this.next) this.next.disabled = atEnd;
  }
}

if (!customElements.get('review-carousel')) {
  customElements.define('review-carousel', ReviewCarousel);
}